import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { FaPhone, FaMapMarkerAlt, FaClock, FaFacebookF, FaInstagram } from 'react-icons/fa';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-dark-navy text-white py-20" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Section */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_premium-workshop-1/artifacts/9y8bohg9_LK.jpg" 
                alt="Leng Kee Auto Service Centre Logo"
                className="w-14 h-14 object-contain bg-white rounded-full p-1"
              />
              <div>
                <div className="font-cabinet font-extrabold text-lg leading-tight">LENG KEE AUTO</div>
                <div className="text-xs text-gray-400 tracking-wider">SERVICE CENTRE</div>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mt-4">
              {t('footer.aboutDesc')}
            </p>
            <div className="flex space-x-4 mt-6">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="facebook-link"
                className="w-10 h-10 border border-gray-600 rounded-full flex items-center justify-center hover:border-royal-blue hover:text-royal-blue transition-colors"
              >
                <FaFacebookF size={18} />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="instagram-link"
                className="w-10 h-10 border border-gray-600 rounded-full flex items-center justify-center hover:border-royal-blue hover:text-royal-blue transition-colors"
              >
                <FaInstagram size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-cabinet font-bold text-lg mb-6">{t('footer.quickLinks')}</h3>
            <ul className="space-y-3">
              {['/', '/about', '/services', '/hybrid', '/gallery', '/why-choose-us', '/reviews', '/faq', '/contact'].map((path, i) => (
                <li key={path}>
                  <Link
                    to={path}
                    className="text-gray-400 text-sm hover:text-white transition-colors inline-block"
                  >
                    {t(`nav.${['home', 'about', 'services', 'hybrid', 'gallery', 'why', 'reviews', 'faq', 'contact'][i]}`)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-cabinet font-bold text-lg mb-6">{t('footer.servicesTitle')}</h3>
            <ul className="space-y-3 text-gray-400 text-sm">
              <li>{t('services.europeanRepair')}</li>
              <li>{t('services.diagnostics')}</li>
              <li>{t('services.maintenance')}</li>
              <li>{t('services.hybrid')}</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-cabinet font-bold text-lg mb-6">{t('footer.contactTitle')}</h3>
            <div className="space-y-4 text-gray-400 text-sm">
              <div className="flex items-start space-x-3">
                <FaMapMarkerAlt className="text-royal-blue mt-1 flex-shrink-0" />
                <span>Lot 3663, Batu 1 3/4 Jalan Bakri 84000 Muar Johor</span>
              </div>
              <div className="flex items-center space-x-3">
                <FaPhone className="text-royal-blue flex-shrink-0" />
                <a href="tel:+6069513317" className="hover:text-white transition-colors">
                  +606-951 3317
                </a>
              </div>
              <div className="flex items-start space-x-3">
                <FaClock className="text-royal-blue mt-1 flex-shrink-0" />
                <span>Mon – Sat<br />8:30 AM – 5:30 PM</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 mt-12 text-center">
          <p className="text-sm text-gray-400">
            © {new Date().getFullYear()} LENG KEE AUTO SERVICE CENTRE SDN BHD (龙记汽车服务中心有限公司). {t('footer.rights')}
          </p>
          <p className="text-xs text-gray-500 mt-2">{t('footer.tagline')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;